import type { AdvertiserBrand, ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

/** 供應商的品牌管理表（含停用的） */
export function useSupplierBrands(supplierId: number | null | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<AdvertiserBrand[]>>(
    token && supplierId ? `/api/ad-supplier/${supplierId}/brands` : null,
    undefined,
    token ?? '',
  )
  return { brands: data?.data ?? [], isLoading, isError: error, mutate }
}
